import * as React from "react";
import {
  Show,
  Datagrid,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  useTranslate,
  FunctionField,
  ArrayField,
} from "react-admin";
import {
  DateField,
  Title,
  ShowOnlyTopToolbar,
} from "../../shared/components/index.js";
import Merchants from "./merchants.js";

const DefaultClient = () => {
  const t = useTranslate();

  return (
    <Show title={<Title source="phone" />} actions={<ShowOnlyTopToolbar />}>
      <SimpleShowLayout>
        <TextField source="phone" />
        <TextField source="email" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <ReferenceField source="category_id" reference="Category" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceArrayField source="tag_ids" reference="Tag">
          <SingleFieldList linkType="show">
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Client.source.status.${record.status}`)
          }
        />

        <ArrayField
          source="unconfirmed_changes"
          label="resources.Client.fields.unconfirmed_changes.name"
        >
          <Datagrid optimized bulkActionButtons={null}>
            <TextField
              source="field_name"
              label="resources.Client.fields.unconfirmed_changes.field_name"
            />
            <TextField
              source="value"
              label="resources.Client.fields.unconfirmed_changes.value"
            />
            <FunctionField
              source="status"
              render={(record) =>
                t(`resources.Client.source.changes_status.${record.status}`)
              }
            />
          </Datagrid>
        </ArrayField>
        <FunctionField
          source="deleted_at"
          render={(record) => {
            if (record && record.deleted_at) {
              return <DateField source="deleted_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.deleted"
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </SimpleShowLayout>
    </Show>
  );
};

const showClient = () => {
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.multiplePaymentGateways,
  ];

  if (plugins && nonDefaultClientRequires.some((plugin) => plugin === true)) {
    return Merchants[merchant].ShowClient();
  } else {
    return <DefaultClient />;
  }
};

export default showClient;
